var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVLiteMooc02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3069_82173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7213 42.002H1.93164C1.23697 42.002 0.673828 41.4388 0.673828 40.7441V38.7676C0.673828 38.0729 1.23697 37.5098 1.93164 37.5098H44.0684C44.7631 37.5098 45.3262 38.0729 45.3262 38.7676V40.7441C45.3262 41.4388 44.7631 42.002 44.0684 42.002H31.6632",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68368 14.7505L3.68359 12.3543C3.68359 11.3624 4.4877 10.5574 5.48047 10.5574H9.79297",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 10.5566H40.5186C41.5114 10.5566 42.3155 11.3607 42.3155 12.3535L42.3164 35.712C42.3164 36.7039 41.5123 37.5089 40.5195 37.5089L5.48137 37.5098C4.4886 37.5098 3.6845 36.7057 3.6845 35.7129L3.68378 17.6339",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.207 13.252H39.6202L39.6211 34.8136L6.37981 34.8145L6.37891 13.2529H9.79297",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8.55672V25.2012H10.2961C10.0185 25.2012 9.79297 24.9757 9.79297 24.698V9.05985C9.79297 8.78223 10.0185 8.55672 10.2961 8.55672H12.0849",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 8.55672V25.2012H35.7039C35.9815 25.2012 36.207 24.9757 36.207 24.698V9.05985C36.207 8.78223 35.9815 8.55672 35.7039 8.55672H33.9151",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 25.2012L12.424 21.5439C12.2212 21.4737 12.0852 21.2828 12.0852 21.0683V4.50171C12.0852 4.15581 12.4262 3.91306 12.7531 4.02617L23.0001 7.56961V25.2012Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4073 5.69969L23 7.56952V25.2012L33.576 21.5439C33.7788 21.4736 33.9149 21.2827 33.9149 21.0683V4.50171C33.9149 4.15572 33.574 3.91297 33.2469 4.02608L31.1245 4.76001",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8543 39.666H20.1458C19.5885 39.666 19.1367 39.2143 19.1367 38.6571V37.5098H26.8633V38.6571C26.8633 39.2143 26.4115 39.666 25.8543 39.666Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1494 28.4705H31.8507",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1494 31.3289H25.6291",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3069_82173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLiteMooc02);
export default __webpack_public_path__ + "static/media/vLite-MOOC02.91c93f34f84dbff0c4cf05d610c7445d.svg";
export { ForwardRef as ReactComponent };